import { configureStore } from '@reduxjs/toolkit'
 import DriverSlice from './pages/presentation/Relie_Admin/DRIVERCRUD copy/DriverSlice/DriverSlice'
 import CustomerSlice from './pages/presentation/Relie_Admin/Customer/CustomerSlice/Slice'
 import RideSlice from './pages/presentation/Relie_Admin/RideBook/RideSilce/RideSlice'
 import FareSlice from './pages/presentation/Relie_Admin/ManageFare/FareSilce/FareSilce'

const store=configureStore({
    reducer:{
        driver:DriverSlice,
        customer:CustomerSlice,
        ride:RideSlice,
        fare:FareSlice
    }
})
export default store
